export const TruckModel = {
    id: "",
    plate: "",
    identifier: "",
    brand: "",
    model: "",
    capacity_kg: "",
    volume: "",
    autonomy: "",
    download_type: "",
    active: true,
};
